import React from "react";
import "./InfoComponent.css";
import DOMPurify from "dompurify";

export default function InfoComponent(props) {
  const sanitizedHTML = DOMPurify.sanitize(props.content.text);
  return (
    <div className="infoContainer">
      <div
        className="infoText"
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      />
    </div>
  );
}
